import React from 'react';
import EditTimelineContainer from 'containers/edit/EditTimelineContainer';
import EditSnapshotContainer from 'containers/edit/EditSnapshotContainer';
import EditWrapContainer from 'containers/edit/EditWrapContainer';
import {t} from 'lib/i18n';

/**
 * 편집 영역 템플릿 컴포넌트
 */

interface IEditAreaProps {
  editStatus: string;
  clearBtn: string;
  onInitialClick(): void;
}

const EditArea = ({editStatus, clearBtn, onInitialClick}: IEditAreaProps) => {
  return (
    <div className={'vod_ctrl_space ' + editStatus}>
      <button className={'btn_clear_all ' + clearBtn} onClick={onInitialClick}>
        {t('초기화')}
      </button>
      <EditTimelineContainer />
      <EditSnapshotContainer />
      {/* <EditAudioContainer /> */}
      <EditWrapContainer />
    </div>
  );
};

export default EditArea;
